import { VerlaufButton, VerlaufKomplett } from "./LinienführungAnlegenCss";

export default function AuswahlHinrichtungAusVorherigen({ previousVerlaeufe, previousHin, hrCollection, setHrCollection }) {

    function handleBisherChange(e) {
        e.preventDefault();
        setHrCollection({
            ...hrCollection,
            bisherigeStrNutzen: !hrCollection.bisherigeStrNutzen,
            neueStrecke: false,
            hrHalte: {},
            hrVerlauf: [],
            hrStreckenId: undefined,
            mirrored: undefined
        });
    }

    function handleAuswahlRadios(radioValue, verlaufId) {
        let specificVerlauf = previousVerlaeufe.filter(v => v.id === verlaufId);
        let verlauf = specificVerlauf[0].ext_verlauf_hr;

        verlauf.forEach(station => station["verlauf"] = specificVerlauf[0].verlauf_hr.includes(station.id_bhf))

        let halte = {};
        specificVerlauf[0].ext_verlauf_hr.forEach(station => {
            halte[station.pos] = specificVerlauf[0].halt_hr.includes(station.pos)
        });

        setHrCollection({
            ...hrCollection,
            hrStreckenId: radioValue,
            hrVerlauf: verlauf,
            hrHalte: halte,
            neueStrecke: false,
            mirrored: specificVerlauf[0].mirrored_hr
        });
    }

    function handleVerlaufChange(bhfPos) {
        let completeStation = hrCollection.hrVerlauf.filter(station => station.pos === parseInt(bhfPos))[0];
        let currentState = completeStation.verlauf;
        completeStation.verlauf = !currentState;
        if (!currentState) {
            // nur wenn verlauf auf ja, dann halt auch
            handleHalteChange(bhfPos, true);
        }

        let completeVerlauf = hrCollection.hrVerlauf.filter(station => station.pos !== parseInt(bhfPos));
        completeVerlauf.push(completeStation);

        setHrCollection({
            ...hrCollection,
            hrVerlauf: completeVerlauf
        });
    }

    function handleHalteChange(bhfPos, newState) {
        let currentHalte = hrCollection.hrHalte;
        currentHalte[bhfPos] = newState;

        if (!newState) {
            // wenn auf nein, dann auch verlauf nein
            setVerlaufFalse(bhfPos);
        }

        setHrCollection({
            ...hrCollection,
            hrHalte: currentHalte
        });
    }

    function setVerlaufFalse(bhfPos) {
        let completeStation = hrCollection.hrVerlauf.filter(station => station.pos === parseInt(bhfPos))[0];
        completeStation.verlauf = false;
        let completeVerlauf = hrCollection.hrVerlauf.filter(station => station.pos !== parseInt(bhfPos));
        completeVerlauf.push(completeStation);

        setHrCollection({
            ...hrCollection,
            hrVerlauf: completeVerlauf
        });
    }

    function updateRadios(e, verlaufId) {
        handleAuswahlRadios(parseInt(e.target.value), verlaufId);
    }

    const orderingVerlauf = (ext_verlauf, mirror) => {
        if (mirror) {
            return [...ext_verlauf].sort((a, b) => a.pos < b.pos)
        } else {
            return [...ext_verlauf].sort((a, b) => a.pos > b.pos)
        }
    }

    const updateVerlauf = (e) => {
        e.preventDefault();
        handleVerlaufChange(e.target.id);
    }

    function updateHalte(e) {
        handleHalteChange(e.target.value, e.target.checked);
    }

    return (
        <div>
            <button className="ausklappsie" onClick={handleBisherChange}>
                <label>{hrCollection.bisherigeStrNutzen ? <span>&#8722; </span> : <span>&#43; </span>}bisherige Strecken dieser Linie:</label>
            </button>
            {hrCollection.bisherigeStrNutzen && previousHin.map((verlauf, index) =>
                <section className="ausklappsie-klappe" key={`${verlauf.id} - ${index}`} >
                    <fieldset onChange={(e) => { updateRadios(e, verlauf.id) }} key={index}>
                                                <label>
                            <input id="vorgänger" type="radio" name="vorgänger"
                                value={verlauf.id_strecke}
                            />
                            Vorgänger: {index + 1} {verlauf.id_strecke} {verlauf.verlauf}
                        </label>
                    </fieldset>
                {/* </section>)}
            {hrCollection.bisherigeStrNutzen && previousVerlaeufe.map((verlauf, index) =>
                <section className="ausklappsie-klappe" key={`${verlauf.id} - ${index}`} >
                    <fieldset onChange={(e) => { updateRadios(e, verlauf.id) }}>
                        <label>
                            <input id="vorgänger" type="radio" name="vorgänger"
                                value={verlauf.id_strecke_hr}
                            />
                            Vorgänger: {index + 1} {verlauf.id_strecke_hr} {verlauf.verlauf_hr}
                        </label>
                    </fieldset> */}

                    <section style={{ marginLeft: "2em" }}>
                        <p style={{ fontSize: 'small' }}>{verlauf.gueltig_von} - {verlauf.gueltig_bis}</p>
                        <p>{JSON.stringify(hrCollection.hrStreckenId)} {JSON.stringify(verlauf.id_strecke)}</p>
                        {hrCollection.hrStreckenId === verlauf.id_strecke
                            ? <div>
                                <VerlaufKomplett>
                                    <thead>
                                        <tr>
                                            <th>in Verlaufsbeschreibung</th>
                                            <th>Halt</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {orderingVerlauf(verlauf.ext_verlauf, verlauf.mirrored).map(bhf =>
                                            <tr key={bhf.pos}>
                                                <td>
                                                    {/* verlauf */}
                                                    <VerlaufButton id={bhf.pos} value={bhf.pos} onClick={(e) => updateVerlauf(e)}
                                                        className={hrCollection.hrVerlauf.filter(station => station.pos === bhf.pos)[0].verlauf ? "active" : "inactive"}>
                                                        <span id={bhf.pos}>{bhf.pos}: </span>{bhf.bhf}</VerlaufButton>
                                                </td>
                                                {/* halte */}
                                                <td>
                                                    <input type="checkbox" value={bhf.pos} onChange={(e) => updateHalte(e)}
                                                        // disabled={!hrCollection.hrVerlauf.filter(station => station.pos === parseInt(bhf.pos))[0].verlauf}
                                                        checked={hrCollection.hrHalte[bhf.pos]} />
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </VerlaufKomplett>
                                {hrCollection.hrVerlauf.length === 0
                                    ? <>
                                        <label>Verlauf bisher *: {verlauf.verlauf}</label>
                                        <aside style={{ fontSize: 'small' }}>* nimmt Verlauf aus vorheriger Linienführung, oder neu festlegen durch Häkchen setzen</aside>
                                    </>
                                    : <>
                                        <label>neuer Verlauf: </label>
                                        {hrCollection.hrVerlauf
                                            .sort((a, b) => a.pos > b.pos)
                                            .filter(b => b.verlauf)
                                            .map(e => `-${e.bhf}-`)}
                                    </>}
                            </div>
                            : <p style={{ fontSize: 'small' }}>{orderingVerlauf(verlauf.ext_verlauf, verlauf.mirrored).map(bhf => `- ${bhf.pos}: ${bhf.bhf} -`)}</p>}
                    </section>

                </section>)
            }
        </div>
    )
}